/* eslint-disable import/order */
const en = require('./default.json');
const hi = require('./hi.json');

// import {addLocaleData} from 'react-intl';
// import * as enLocaleData from 'react-intl/locale-data/en';
// import * as hiLocaleData from 'react-intl/locale-data/hi';


const languages = {
    en: {
        value: 'en',
        name: 'English',
        url: en,
    },
    hi: {
        value: 'hi',
        name: 'hindi',
        url: hi,
    }
};

export function getLanguageInfo(locale) {
    return languages[locale];
}

export function isLanguageAvailable(locale) {
    return Boolean(languages[locale]);
}

// export function safariFix(callback:Function) {
//     (require as any).ensure([
//         'intl',
//         'intl/locale-data/jsonp/en.js'
//     ], (require:NodeRequire) => {
//         require('intl');
//         require('intl/locale-data/jsonp/en.js');
//         callback();
//     });
// }

// export function doAddLocaleData() {
//     addLocaleData(enLocaleData);
//     addLocaleData(hiLocaleData);
// }